// @flow
import React, { Component } from 'react';
import { View } from 'react-native';
import { Text } from 'trpc-react-native-ui';
import { Icon } from '../common';
import I18n from '../../lib/i18n';
import theme from '../../theme-config';
import { getStyles } from './styles';
import { StyleSheet, Dimensions } from 'react-native';

export default class DeliveryAddress extends Component<Props> {
  styles = getStyles();
  deliveryAddressStyles = getDeliveryAddressStyles();

  render() {
    const textContainerStyle = {
      marginLeft: 16,
    };
    const { postCode, city, street1, street2, deliveryInstruction, houseNumber, fullName } = this.props.deliveryAddress;
    return (
      <View style={[this.styles.container, this.props.style]}>
        <Icon name="location" color={this.props.neutralColors ? theme.gray.light : theme.signUpIconColor} size={26} />
        <View style={[this.styles.textContainer, textContainerStyle]}>
          <Text
            style={[
              this.styles.text,
              this.deliveryAddressStyles.wrappedText,
              this.props.neutralColors && this.styles.neutralText,
            ]}
          >
            {fullName}
          </Text>
          <Text
            style={[
              this.styles.legend,
              this.deliveryAddressStyles.wrappedText,
              this.props.neutralColors && this.styles.neutralLegend,
            ]}
          >
            {houseNumber && `${houseNumber}, `}
            {street1}
          </Text>
          {!!street2 && (
            <Text
              style={[
                this.styles.legend,
                this.deliveryAddressStyles.wrappedText,
                this.props.neutralColors && this.styles.neutralLegend,
              ]}
            >
              {street2}
            </Text>
          )}
          <Text
            style={[
              this.styles.legend,
              this.deliveryAddressStyles.wrappedText,
              this.props.neutralColors && this.styles.neutralLegend,
            ]}
          >{`${postCode}, ${city}`}</Text>
          {!!deliveryInstruction && (
            <Text style={[this.styles.legend, this.props.neutralColors && this.styles.neutralLegend]}>
              {I18n.t('SignUp.ConfirmPlan.instructions')} {deliveryInstruction}
            </Text>
          )}
        </View>
      </View>
    );
  }
}

type Props = {
  deliveryAddress: any,
  neutralColors?: boolean,
  style?: any,
};

function getDeliveryAddressStyles() {
  return StyleSheet.create({
    wrappedText: {
      width: Dimensions.get('window').width - 74,
      flexWrap: 'wrap',
    },
  });
}
